import {once} from '@packages/utilities/memo';
import {Plugins} from '@packages/systems/wfdl';
import {
  Symbol,
  PrebuiltLayouts,
  make__SitePlugin,
} from '@packages/systems/core/plugins';
import {plugin as Builtin} from '@packages/systems/plugins/Builtin';
import {plugin as Json} from '@packages/systems/plugins/Json';
import {plugin as Effect} from '@packages/systems/plugins/Effect';
import {plugin as Http} from '@packages/systems/plugins/Http';
import {plugin as BackgroundVideo} from './plugins/BackgroundVideo/index';
import {plugin as BaseSiteModules} from './plugins/BaseSiteModules/index';
import {plugin as Basic} from './plugins/Basic/index';
import {plugin as Body} from './plugins/Body';
import {plugin as Commerce} from './plugins/Commerce/index';
import {plugin as CMS} from '@packages/systems/plugins/CMS';
import {plugin as Conditional} from '@packages/systems/plugins/Conditional';
import {plugin as Dropdown} from './plugins/Dropdown/index';
import {plugin as Dynamo} from './plugins/Dynamo/index';
import {plugin as Embed} from './plugins/Embed/index';
import {plugin as Form} from './plugins/Form/index';
import {plugin as Animation} from './plugins/Animation/index';
import {plugin as Icon} from './plugins/Icon';
import {plugin as Lab} from './plugins/Lab';
import {plugin as Localization} from '@packages/systems/plugins/Localization';
import {plugin as Modal} from '@packages/systems/plugins/Modal';
import {plugin as Popover} from '@packages/systems/plugins/Popover';
import {plugin as PrivilegedLab} from './plugins/PrivilegedLab';
import {plugin as Layout} from './plugins/Layout/index';
import {plugin as Lightbox} from './plugins/Lightbox/index';
import {plugin as Navbar} from './plugins/Navbar/index';
import {plugin as Pagination} from './plugins/Pagination/index';
import {plugin as Search} from './plugins/Search/index';
import {plugin as Secret} from '@packages/systems/plugins/Secret';
import {plugin as Slider} from './plugins/Slider/index';
import {plugin as Ssr} from './plugins/Ssr';
import {plugin as Tabs} from './plugins/Tabs/index';
import {plugin as Widget} from './plugins/Widget/index';
import {plugin as Asset} from './plugins/Asset/index';
import {plugin as Visibility} from './plugins/Visibility/index';
import {plugin as Users} from './plugins/Users/index';
import {plugin as IX3} from '@packages/systems/plugins/IX3';

import {plugin as Text} from '@packages/systems/plugins/Text';

import {plugin as DateTime} from '@packages/systems/plugins/DateTime';
import {plugin as Phone} from '@packages/systems/plugins/Phone';
import {plugin as Email} from '@packages/systems/plugins/Email';
import {plugin as Color} from '@packages/systems/plugins/Color';
import {plugin as Link} from '@packages/systems/plugins/Link';
import {plugin as Video} from '@packages/systems/plugins/Video';
import {plugin as Number} from '@packages/systems/plugins/Number';
import {plugin as Boolean} from '@packages/systems/plugins/Boolean';
import {plugin as List} from '@packages/systems/plugins/List';
import {plugin as FormLogic} from '@packages/systems/plugins/FormLogic';
import {plugin as Logic} from '@packages/systems/flows/plugins';
import {plugin as Option} from '@packages/systems/plugins/Option';
import {plugin as Collaborators} from '@packages/systems/plugins/Collaborators';
import {plugin as UsersPlugin} from '@packages/systems/plugins/Users';
import {plugin as DateCondition} from '@packages/systems/plugins/DateCondition';

import {plugin as DynamoGateway} from '@packages/systems/plugins/DynamoGateway';
import {plugin as Devlink} from '@packages/systems/plugins/Devlink';
import {plugin as Slots} from '@packages/systems/plugins/Slots';
import {plugin as PageBuilding} from '@packages/systems/plugins/PageBuilding';

import {plugin as Optimization} from '@packages/systems/plugins/Optimization';
import {plugin as Code} from '@packages/systems/plugins/Code';
import {plugin as Frame} from '@packages/systems/plugins/Frame';

import {plugin as Conditionals} from '@packages/systems/plugins/Conditionals';
import {plugin as Conditions} from '@packages/systems/plugins/Conditions';
import {plugin as ConditionsOperand} from '@packages/systems/plugins/ConditionsOperand';
import {plugin as ListOfElements} from '@packages/systems/plugins/ListOfElements';

import {plugin as Enum} from '@packages/systems/plugins/Enum';

// This set should be used as a helper for test setups instead of
// `corePlugins` for a minimal set of required Plugins.
// Do not use in production code unless you know what you are doing.
export const integratedTypesPlugins = {
  // Required by Integrated Types
  Basic,
  Asset,
  Visibility,
  Search,
  Devlink,
  Boolean,
  ConditionsOperand,
  // Required by the Renderer when seeing
  // user components
  Symbol,
};

export const corePlugins: Plugins.PluginDeclarationMap = {
  ...integratedTypesPlugins,
  Animation,
  BackgroundVideo,
  BaseSiteModules,
  Body,
  Boolean,
  Commerce,
  CMS,
  Conditional,
  Dropdown,
  PageBuilding,
  Dynamo,
  DynamoGateway,
  Embed,
  Form,
  Json,
  Effect,
  Http,
  Icon,
  IX3,
  Lab,
  List,
  Localization,
  Modal,
  Popover,
  PrivilegedLab,
  Layout,
  Lightbox,
  Navbar,
  Number,
  Pagination,
  Secret,
  Slider,
  Ssr,
  Tabs,
  Text,
  Widget,
  PrebuiltLayouts,
  Users,
  DateTime,
  Phone,
  Email,
  Color,
  Link,
  Video,
  'Form Logic': FormLogic,
  Logic,
  Option,
  Collaborators,
  UsersPlugin,
  Slots,
  Optimization,
  Code,
  Frame,
  Conditionals,
  Conditions,
  Enum,
  ListOfElements,
  DateCondition,
};

export default corePlugins;

export const getBootstrappedPlugins: () => Plugins.PluginsType = once(() =>
  Plugins.bootstrap({
    ...corePlugins,
    Builtin,
    __SitePlugin: make__SitePlugin({timezone: 'UTC'}),
  })
);
